import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getPdfToolbarSuffix, opensInNewTab } from '../fileTypes'

/**
 * Wraps a library file card in the right kind of link:
 *  - "open in new tab" files -> plain <a target="_blank"> to the file itself
 *  - everything else         -> in-app viewer (/library/url/:id, see UrlModal)
 */
const FileLink = ({ item, children, ...rest }) => {
  const { pdfjsDownloadAndPrint } = useSelector((store) => store.generalConfig)

  if (opensInNewTab(item)) {
    return (
      <a
        href={`${item?.path}${getPdfToolbarSuffix(item, pdfjsDownloadAndPrint)}`}
        target='_blank'
        rel='noreferrer'
        {...rest}
      >
        {children}
      </a>
    )
  }

  return (
    <Link to={`/library/url/${item?.id}`} {...rest}>
      {children}
    </Link>
  )
}

export default FileLink
